import React from "react";
import { Box, Typography, Divider } from "@mui/material";
import Co2Icon from "@mui/icons-material/Co2";
import WaterDropIcon from "@mui/icons-material/WaterDrop";
import PetsIcon from "@mui/icons-material/Pets";

type Metric = {
  label: string;
  value: string | number;
  unit: string;
  icon?: React.ReactNode; // Optional icon
};

type EcoMetricsRowProps = {
  metrics: Metric[];
};

const EcoMetricsRow: React.FC<EcoMetricsRowProps> = ({ metrics }) => {
  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      bgcolor="#F5F9E9"
      borderRadius={2}
      padding={2}
      sx={{ boxShadow: 1 }}
    >
      {metrics.map((metric, index) => (
        <React.Fragment key={index}>
          <Box flex={1} textAlign="center">
            <Box mb={1}>{metric.icon}</Box>
            <Typography variant="h6" fontWeight="bold" color="#162C1F">
              {metric.value} {metric.unit}
            </Typography>
            <Typography variant="body2" color="#4A645F">
              {metric.label}
            </Typography>
          </Box>
          {index < metrics.length - 1 && (
            <Divider
              orientation="vertical"
              flexItem
              sx={{ mx: 2, bgcolor: "#DADADA" }}
            />
          )}
        </React.Fragment>
      ))}
    </Box>
  );
};

export default EcoMetricsRow;
